var _slicedToArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.graphqlWs = {}));
})(this, function (exports) {
  'use strict'; // Extremely small optimisation, reduces runtime prototype traversal

  var baseHasOwnProperty = Object.prototype.hasOwnProperty;
  /** @private */

  function isObject(val) {
    return typeof val === 'object' && val !== null;
  }
  /** @private */


  function areGraphQLErrors(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every(function (ob) {
      return 'message' in ob;
    });
  }
  /** @private */


  function hasOwnProperty(obj, prop) {
    return baseHasOwnProperty.call(obj, prop);
  }
  /** @private */


  function hasOwnObjectProperty(obj, prop) {
    return baseHasOwnProperty.call(obj, prop) && isObject(obj[prop]);
  }
  /** @private */


  function hasOwnStringProperty(obj, prop) {
    return baseHasOwnProperty.call(obj, prop) && typeof obj[prop] === 'string';
  }
  /**
   *
   * common
   *
   */

  /**
   * The WebSocket sub-protocol used for the [GraphQL over WebSocket Protocol](/PROTOCOL.md).
   *
   * @category Common
   */


  var GRAPHQL_TRANSPORT_WS_PROTOCOL = 'graphql-transport-ws';
  /**
   * `graphql-ws` expected and standard close codes of the [GraphQL over WebSocket Protocol](/PROTOCOL.md).
   *
   * @category Common
   */

  exports.CloseCode = void 0;

  (function (CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    /** Tried subscribing before connect ack */

    CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */

    CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
  })(exports.CloseCode || (exports.CloseCode = {}));
  /**
   * Types of messages allowed to be sent by the client/server over the WS protocol.
   *
   * @category Common
   */


  exports.MessageType = void 0;

  (function (MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
  })(exports.MessageType || (exports.MessageType = {}));
  /**
   * Checks if the provided value is a message.
   *
   * @category Common
   */


  function isMessage(val) {
    if (isObject(val)) {
      // all messages must have the `type` prop
      if (!hasOwnStringProperty(val, 'type')) {
        return false;
      } // validate other properties depending on the `type`


      switch (val.type) {
        case exports.MessageType.ConnectionInit:
          // the connection init message can have optional payload object
          return !hasOwnProperty(val, 'payload') || val.payload === undefined || isObject(val.payload);

        case exports.MessageType.ConnectionAck:
        case exports.MessageType.Ping:
        case exports.MessageType.Pong:
          // the connection ack, ping and pong messages can have optional payload object too
          return !hasOwnProperty(val, 'payload') || val.payload === undefined || isObject(val.payload);

        case exports.MessageType.Subscribe:
          return hasOwnStringProperty(val, 'id') && hasOwnObjectProperty(val, 'payload') && (!hasOwnProperty(val.payload, 'operationName') || val.payload.operationName === undefined || val.payload.operationName === null || typeof val.payload.operationName === 'string') && hasOwnStringProperty(val.payload, 'query') && (!hasOwnProperty(val.payload, 'variables') || val.payload.variables === undefined || val.payload.variables === null || hasOwnObjectProperty(val.payload, 'variables')) && (!hasOwnProperty(val.payload, 'extensions') || val.payload.extensions === undefined || val.payload.extensions === null || hasOwnObjectProperty(val.payload, 'extensions'));

        case exports.MessageType.Next:
          return hasOwnStringProperty(val, 'id') && hasOwnObjectProperty(val, 'payload');

        case exports.MessageType.Error:
          return hasOwnStringProperty(val, 'id') && areGraphQLErrors(val.payload);

        case exports.MessageType.Complete:
          return hasOwnStringProperty(val, 'id');

        default:
          return false;
      }
    }

    return false;
  }
  /**
   * Parses the raw websocket message data to a valid message.
   *
   * @category Common
   */


  function parseMessage(data, reviver) {
    if (isMessage(data)) {
      return data;
    }

    if (typeof data !== 'string') {
      throw new Error('Message not parsable');
    }

    var message = JSON.parse(data, reviver);

    if (!isMessage(message)) {
      throw new Error('Invalid message');
    }

    return message;
  }
  /**
   * Stringifies a valid message ready to be sent through the socket.
   *
   * @category Common
   */


  function stringifyMessage(msg, replacer) {
    if (!isMessage(msg)) {
      throw new Error('Cannot stringify invalid message');
    }

    return JSON.stringify(msg, replacer);
  }
  /**
   *
   * client
   *
   */

  /**
   * Creates a disposable GraphQL over WebSocket client.
   *
   * @category Client
   */


  function createClient(options) {
    var url = options.url,
        connectionParams = options.connectionParams,
        _options$lazy = options.lazy,
        lazy = _options$lazy === void 0 ? true : _options$lazy,
        _options$onNonLazyErr = options.onNonLazyError,
        onNonLazyError = _options$onNonLazyErr === void 0 ? console.error : _options$onNonLazyErr,
        _options$lazyCloseTim = options.lazyCloseTimeout,
        lazyCloseTimeout = _options$lazyCloseTim === void 0 ? 0 : _options$lazyCloseTim,
        _options$keepAlive = options.keepAlive,
        keepAlive = _options$keepAlive === void 0 ? 0 : _options$keepAlive,
        disablePong = options.disablePong,
        _options$connectionAc = options.connectionAckWaitTimeout,
        connectionAckWaitTimeout = _options$connectionAc === void 0 ? 0 : _options$connectionAc,
        _options$retryAttempt = options.retryAttempts,
        retryAttempts = _options$retryAttempt === void 0 ? 5 : _options$retryAttempt,
        _options$retryWait = options.retryWait,
        retryWait = _options$retryWait === void 0 ? /*#__PURE__*/function () {
      var _randomisedExponentialBackoff = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retries) {
        var retryDelay, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                retryDelay = 1000; // start with 1s delay

                for (i = 0; i < retries; i++) {
                  retryDelay *= 2;
                }

                _context.next = 4;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
                  Math.floor(Math.random() * (3000 - 300) + 300));
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function randomisedExponentialBackoff(_x) {
        return _randomisedExponentialBackoff.apply(this, arguments);
      }

      return randomisedExponentialBackoff;
    }() : _options$retryWait,
        _options$isFatalConne = options.isFatalConnectionProblem,
        isFatalConnectionProblem = _options$isFatalConne === void 0 ? function (errOrCloseEvent) {
      return (// non `CloseEvent`s are fatal by default
        !isLikeCloseEvent(errOrCloseEvent)
      );
    } : _options$isFatalConne,
        on = options.on,
        webSocketImpl = options.webSocketImpl,
        _options$generateID = options.generateID,
        generateID = _options$generateID === void 0 ? function generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    } : _options$generateID,
        replacer = options.jsonMessageReplacer,
        reviver = options.jsonMessageReviver;
    var ws;

    if (webSocketImpl) {
      if (!isWebSocket(webSocketImpl)) {
        throw new Error('Invalid WebSocket implementation provided');
      }

      ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') {
      ws = WebSocket;
    } else if (typeof global !== 'undefined') {
      ws = global.WebSocket || // @ts-expect-error: Support more browsers
      global.MozWebSocket;
    } else if (typeof window !== 'undefined') {
      ws = window.WebSocket || // @ts-expect-error: Support more browsers
      window.MozWebSocket;
    }

    if (!ws) throw new Error('WebSocket implementation missing');
    var WebSocketImpl = ws; // websocket status emitter, subscriptions are handled differently

    var emitter = function () {
      var message = function () {
        var listeners = {};
        return {
          on: function on(id, listener) {
            listeners[id] = listener;
            return function () {
              delete listeners[id];
            };
          },
          emit: function emit(message) {
            var _a;

            if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 ? void 0 : _a.call(listeners, message);
          }
        };
      }();

      var listeners = {
        connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [on.connecting] : [],
        opened: (on === null || on === void 0 ? void 0 : on.opened) ? [on.opened] : [],
        connected: (on === null || on === void 0 ? void 0 : on.connected) ? [on.connected] : [],
        ping: (on === null || on === void 0 ? void 0 : on.ping) ? [on.ping] : [],
        pong: (on === null || on === void 0 ? void 0 : on.pong) ? [on.pong] : [],
        message: (on === null || on === void 0 ? void 0 : on.message) ? [message.emit, on.message] : [message.emit],
        closed: (on === null || on === void 0 ? void 0 : on.closed) ? [on.closed] : [],
        error: (on === null || on === void 0 ? void 0 : on.error) ? [on.error] : []
      };
      return {
        onMessage: message.on,
        on: function on(event, listener) {
          var l = listeners[event];
          l.push(listener);
          return function () {
            l.splice(l.indexOf(listener), 1);
          };
        },
        emit: function emit(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var _iterator = _createForOfIteratorHelper(listeners[event]),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var listener = _step.value;
              // @ts-expect-error: The args should fit
              listener.apply(void 0, args);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      };
    }();

    var connecting,
        locks = 0,
        retrying = false,
        retries = 0,
        disposed = false;

    function connect() {
      return _connect.apply(this, arguments);
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */


    function _connect() {
      _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _yield, _yield2, socket, throwOnClose, release, released;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise(function (connected, denied) {
                  return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                    var socket, connectionAckTimeout, queuedPing, enqueuePing, acknowledged;
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            enqueuePing = function _enqueuePing() {
                              if (isFinite(keepAlive) && keepAlive > 0) {
                                clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)

                                // in case where a pong was received before a ping (this is valid behaviour)
                                queuedPing = setTimeout(function () {
                                  if (socket.readyState === WebSocketImpl.OPEN) {
                                    socket.send(stringifyMessage({
                                      type: exports.MessageType.Ping
                                    }));
                                    emitter.emit('ping', false, undefined);
                                  }
                                }, keepAlive);
                              }
                            };

                            if (!retrying) {
                              _context7.next = 8;
                              break;
                            }

                            _context7.next = 4;
                            return retryWait(retries);

                          case 4:
                            if (locks) {
                              _context7.next = 7;
                              break;
                            }

                            connecting = undefined;
                            return _context7.abrupt("return", denied({
                              code: 1000,
                              reason: 'All Subscriptions Gone'
                            }));

                          case 7:
                            retries++;

                          case 8:
                            emitter.emit('connecting');
                            _context7.t0 = WebSocketImpl;

                            if (!(typeof url === 'function')) {
                              _context7.next = 16;
                              break;
                            }

                            _context7.next = 13;
                            return url();

                          case 13:
                            _context7.t1 = _context7.sent;
                            _context7.next = 17;
                            break;

                          case 16:
                            _context7.t1 = url;

                          case 17:
                            _context7.t2 = _context7.t1;
                            _context7.t3 = GRAPHQL_TRANSPORT_WS_PROTOCOL;
                            socket = new _context7.t0(_context7.t2, _context7.t3);

                            socket.onerror = function (err) {
                              // we let the onclose reject the promise for correct retry handling
                              emitter.emit('error', err);
                            };

                            socket.onclose = function (event) {
                              connecting = undefined;
                              clearTimeout(connectionAckTimeout);
                              clearTimeout(queuedPing);
                              emitter.emit('closed', event);
                              denied(event);
                            };

                            socket.onopen = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                              var payload;
                              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                                while (1) {
                                  switch (_context6.prev = _context6.next) {
                                    case 0:
                                      _context6.prev = 0;
                                      emitter.emit('opened', socket);

                                      if (!(typeof connectionParams === 'function')) {
                                        _context6.next = 8;
                                        break;
                                      }

                                      _context6.next = 5;
                                      return connectionParams();

                                    case 5:
                                      _context6.t0 = _context6.sent;
                                      _context6.next = 9;
                                      break;

                                    case 8:
                                      _context6.t0 = connectionParams;

                                    case 9:
                                      payload = _context6.t0;
                                      socket.send(stringifyMessage(payload ? {
                                        type: exports.MessageType.ConnectionInit,
                                        payload: payload
                                      } : {
                                        type: exports.MessageType.ConnectionInit // payload is completely absent if not provided

                                      }, replacer));

                                      if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) {
                                        connectionAckTimeout = setTimeout(function () {
                                          socket.close(exports.CloseCode.ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                                        }, connectionAckWaitTimeout);
                                      }

                                      enqueuePing(); // enqueue ping (noop if disabled)

                                      _context6.next = 18;
                                      break;

                                    case 15:
                                      _context6.prev = 15;
                                      _context6.t1 = _context6["catch"](0);
                                      socket.close(exports.CloseCode.BadRequest, _context6.t1 instanceof Error ? _context6.t1.message : new Error(_context6.t1).message);

                                    case 18:
                                    case "end":
                                      return _context6.stop();
                                  }
                                }
                              }, _callee6, null, [[0, 15]]);
                            }));
                            acknowledged = false;

                            socket.onmessage = function (_ref5) {
                              var data = _ref5.data;

                              try {
                                var message = parseMessage(data, reviver);
                                emitter.emit('message', message);

                                if (message.type === 'ping' || message.type === 'pong') {
                                  emitter.emit(message.type, true, message.payload); // received

                                  // received
                                  if (message.type === 'pong') {
                                    enqueuePing(); // enqueue next ping (noop if disabled)
                                  } else if (!disablePong) {
                                    // respond with pong on ping
                                    socket.send(stringifyMessage(message.payload ? {
                                      type: exports.MessageType.Pong,
                                      payload: message.payload
                                    } : {
                                      type: exports.MessageType.Pong // payload is completely absent if not provided

                                    }));
                                    emitter.emit('pong', false, message.payload);
                                  }

                                  return; // ping and pongs can be received whenever
                                }

                                if (acknowledged) return; // already connected and acknowledged

                                // already connected and acknowledged
                                if (message.type !== exports.MessageType.ConnectionAck) throw new Error("First message cannot be of type ".concat(message.type));
                                clearTimeout(connectionAckTimeout);
                                acknowledged = true;
                                emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged

                                // connected = socket opened + acknowledged
                                retrying = false; // future lazy connects are not retries

                                // future lazy connects are not retries
                                retries = 0; // reset the retries on connect

                                // reset the retries on connect
                                connected([socket, new Promise(function (_, closed) {
                                  return socket.addEventListener('close', closed);
                                })]);
                              } catch (err) {
                                socket.close(exports.CloseCode.BadRequest, err instanceof Error ? err.message : new Error(err).message);
                              }
                            };

                          case 25:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }))();
                });

              case 2:
                _yield = _context8.sent;
                _yield2 = _slicedToArray(_yield, 2);
                socket = _yield2[0];
                throwOnClose = _yield2[1];

                if (!(socket.readyState === WebSocketImpl.CLOSING)) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 9;
                return throwOnClose;

              case 9:
                release = function release() {// releases this connection
                };

                released = new Promise(function (resolve) {
                  return release = resolve;
                });
                return _context8.abrupt("return", [socket, release, Promise.race([// wait for
                released.then(function () {
                  if (!locks) {
                    // and if no more locks are present, complete the connection
                    var complete = function complete() {
                      return socket.close(1000, 'Normal Closure');
                    };

                    if (isFinite(lazyCloseTimeout) && lazyCloseTimeout > 0) {
                      // if the keepalive is set, allow for the specified calmdown time and
                      // then complete. but only if no lock got created in the meantime and
                      // if the socket is still open
                      setTimeout(function () {
                        if (!locks && socket.readyState === WebSocketImpl.OPEN) complete();
                      }, lazyCloseTimeout);
                    } else {
                      // otherwise complete immediately
                      complete();
                    }
                  }
                }), // or
                throwOnClose])]);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _connect.apply(this, arguments);
    }

    function shouldRetryConnectOrThrow(errOrCloseEvent) {
      // some close codes are worth reporting immediately
      if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [exports.CloseCode.InternalServerError, exports.CloseCode.BadRequest, exports.CloseCode.Unauthorized, // CloseCode.Forbidden, might grant access out after retry
      exports.CloseCode.SubprotocolNotAcceptable, // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      exports.CloseCode.SubscriberAlreadyExists, exports.CloseCode.TooManyInitialisationRequests].includes(errOrCloseEvent.code))) throw errOrCloseEvent; // client was disposed, no retries should proceed regardless

      if (disposed) return false; // normal closure (possibly all subscriptions have completed)
      // if no locks were acquired in the meantime, shouldnt try again

      if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0; // retries are not allowed or we tried to many times, report error

      if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent; // throw fatal connection problems immediately

      if (isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent; // looks good, start retrying

      return retrying = true;
    } // in non-lazy (hot?) mode always hold one connection lock to persist the socket


    if (!lazy) {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$connect, _yield$connect2, throwOnClose;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                locks++;

              case 1:
                _context2.prev = 1;
                _context2.next = 4;
                return connect();

              case 4:
                _yield$connect = _context2.sent;
                _yield$connect2 = _slicedToArray(_yield$connect, 3);
                throwOnClose = _yield$connect2[2];
                _context2.next = 9;
                return throwOnClose;

              case 9:
                _context2.next = 21;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                _context2.prev = 13;

                if (shouldRetryConnectOrThrow(_context2.t0)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return");

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2["catch"](13);
                return _context2.abrupt("return", onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(_context2.t1));

              case 21:
                _context2.next = 1;
                break;

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 11], [13, 18]]);
      }))();
    }

    return {
      on: emitter.on,
      subscribe: function subscribe(payload, sink) {
        var id = generateID();

        var done = false,
            errored = false,
            releaser = function releaser() {
          // for handling completions before connect
          locks--;
          done = true;
        };

        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _ret;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  locks++;

                case 1:
                  _context4.prev = 1;
                  return _context4.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var _yield$connect3, _yield$connect4, socket, release, waitForReleaseOrThrowOnClose, unlisten;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return connect();

                          case 2:
                            _yield$connect3 = _context3.sent;
                            _yield$connect4 = _slicedToArray(_yield$connect3, 3);
                            socket = _yield$connect4[0];
                            release = _yield$connect4[1];
                            waitForReleaseOrThrowOnClose = _yield$connect4[2];

                            if (!done) {
                              _context3.next = 9;
                              break;
                            }

                            return _context3.abrupt("return", {
                              v: release()
                            });

                          case 9:
                            unlisten = emitter.onMessage(id, function (message) {
                              switch (message.type) {
                                case exports.MessageType.Next:
                                  {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    sink.next(message.payload);
                                    return;
                                  }

                                case exports.MessageType.Error:
                                  {
                                    errored = true, done = true;
                                    sink.error(message.payload);
                                    releaser();
                                    return;
                                  }

                                case exports.MessageType.Complete:
                                  {
                                    done = true;
                                    releaser(); // release completes the sink

                                    return;
                                  }
                              }
                            });
                            socket.send(stringifyMessage({
                              id: id,
                              type: exports.MessageType.Subscribe,
                              payload: payload
                            }, replacer));

                            releaser = function releaser() {
                              if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                                socket.send(stringifyMessage({
                                  id: id,
                                  type: exports.MessageType.Complete
                                }, replacer));
                              locks--;
                              done = true;
                              release();
                            }; // either the releaser will be called, connection completed and
                            // the promise resolved or the socket closed and the promise rejected.
                            // whatever happens though, we want to stop listening for messages


                            _context3.next = 14;
                            return waitForReleaseOrThrowOnClose.finally(unlisten);

                          case 14:
                            return _context3.abrupt("return", {
                              v: void 0
                            });

                          case 15:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  })(), "t0", 3);

                case 3:
                  _ret = _context4.t0;

                  if (!(typeof _ret === "object")) {
                    _context4.next = 6;
                    break;
                  }

                  return _context4.abrupt("return", _ret.v);

                case 6:
                  _context4.next = 12;
                  break;

                case 8:
                  _context4.prev = 8;
                  _context4.t1 = _context4["catch"](1);

                  if (shouldRetryConnectOrThrow(_context4.t1)) {
                    _context4.next = 12;
                    break;
                  }

                  return _context4.abrupt("return");

                case 12:
                  _context4.next = 1;
                  break;

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[1, 8]]);
        }))().catch(sink.error) // rejects on close events and errors
        .then(function () {
          // delivering either an error or a complete terminates the sequence
          if (!errored) sink.complete();
        }); // resolves on release or normal closure


        return function () {
          // dispose only of active subscriptions
          if (!done) releaser();
        };
      },
      dispose: function dispose() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _yield$connecting, _yield$connecting2, socket;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  disposed = true;

                  if (!connecting) {
                    _context5.next = 8;
                    break;
                  }

                  _context5.next = 4;
                  return connecting;

                case 4:
                  _yield$connecting = _context5.sent;
                  _yield$connecting2 = _slicedToArray(_yield$connecting, 1);
                  socket = _yield$connecting2[0];
                  socket.close(1000, 'Normal Closure');

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))();
      }
    };
  }

  function isLikeCloseEvent(val) {
    return isObject(val) && 'code' in val && 'reason' in val;
  }

  function isFatalInternalCloseCode(code) {
    if ([1000, 1001, 1006, 1005, 1012, 1013, 1013 // Bad Gateway
    ].includes(code)) return false; // all other internal errors are fatal

    return code >= 1000 && code <= 1999;
  }

  function isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
  }

  exports.GRAPHQL_TRANSPORT_WS_PROTOCOL = GRAPHQL_TRANSPORT_WS_PROTOCOL;
  exports.createClient = createClient;
  exports.isMessage = isMessage;
  exports.parseMessage = parseMessage;
  exports.stringifyMessage = stringifyMessage;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});